module.exports = {
      id: "paywalliconbenefitfour-usage",
      viewBox: "0 0 29.38 29.38",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#paywalliconbenefitfour",
      toString: function () {
        return this.url;
      }
    }